'use client';

import { c as _c } from "react/compiler-runtime";
import { ImageCard } from '~/components/marketing/ImageCard';
import { Section } from '~/components/marketing/Section';
import type { DestinationRecordFragment } from '~/libs/dato/fragments/destinationFragment';
import { getDestinationUrl, getUrl, isExternalPage, type UrlProps } from '~/utils/datoHelpers';
import styles from './CollectionCardGroup.module.css';
import type { CollectionCardGroupProps } from './CollectionCardGroup.types';
type TileSitePage = CollectionCardGroupProps['data']['collectionTiles'][number]['sitePage'];

// Resolve a tile's link. `site_page` is polymorphic, so each record type gets its route prefix:
// DestinationRecord needs the nested destination record (region/country) → getDestinationUrl;
// External returns its verbatim URL (or a localised path via shortSlug); everything else (Inspiration, generic Pages) → getUrl.
const resolveTileHref = (tile: TileSitePage): string | null => {
  if (!tile) return null;
  if (tile.__typename === 'DestinationRecord') {
    const {
      destination
    } = tile as DestinationRecordFragment;
    const slug = tile.slug;
    if (!slug) return null;
    return getDestinationUrl({
      destination: destination ?? undefined,
      slug
    });
  }
  return getUrl(tile as UrlProps);
};
const CollectionCardGroup = t0 => {
  const $ = _c(10);
  const {
    data
  } = t0;
  const handleKeyDown = _temp;
  let t1;
  if ($[0] !== data.title) {
    t1 = <div className={styles.topLine}><h1 className={styles.title}>{data.title}</h1></div>;
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `Scrollable collection of ${data.title}`;
  let t3;
  if ($[2] !== data.collectionTiles) {
    t3 = data?.collectionTiles.map(_temp2);
    $[2] = data.collectionTiles;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className={styles.collectionCardGroupContent} role="region" aria-label={t2} onKeyDown={handleKeyDown}>{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <Section data-test-id="CollectionCardGroup">{t1}{t4}</Section>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export { CollectionCardGroup };
function _temp(e) {
  const container = e.currentTarget;
  if (e.key === "ArrowRight") {
    container.scrollLeft = container.scrollLeft + 200;
    e.preventDefault();
  } else {
    if (e.key === "ArrowLeft") {
      container.scrollLeft = container.scrollLeft - 200;
      e.preventDefault();
    }
  }
}
function _temp2(card, index) {
  if (!card || !card.title) {
    return null;
  }
  const tile = card.sitePage;
  const isExternal = isExternalPage(tile as UrlProps);
  const link = resolveTileHref(tile);
  const collectionsTile = {
    title: card.title,
    backgroundImage: {
      responsiveImage: card.backgroundImage?.responsiveImage || undefined
    },
    excerpt: card.excerpt || "",
    isExternal,
    link
  };
  return <div key={index} className={styles.collectionCard}><ImageCard collectionsTile={collectionsTile} variant="collections" /></div>;
}